// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config$LiveRoom from "../Config.bs.js";

function getSegmentWriteKey(param) {
  if (Config$LiveRoom.tier === "Prod") {
    return "3DPSfpG4OjRBGEMqXhG0ZZsFghihTZso";
  } else {
    return "j0fslOzRidOeIgRHLz8GSkfhmDOevTbo";
  }
}

function reloadPage(param) {
  var reload = (function () {
      window.location.reload();
    });
  Curry._1(reload, undefined);
}

function ConsentManagerDialog$ConsentManager(props) {
  React.useEffect((function () {
          var initSegment = (function () {
          if (window.SothebysShared && window.SothebysShared.findSegmentIntegrations) {
            window.SothebysShared.findSegmentIntegrations(getSegmentWriteKey()).then(function (integrations) {
              analytics.load(getSegmentWriteKey(), { integrations: integrations })
            });
  
            window.addEventListener('OTConsentApplied', reloadPage);
          }
        });
          var cleanUp = (function () {
          window.removeEventListener('OTConsentApplied', reloadPage);
        });
          Curry._1(initSegment, undefined);
          return cleanUp;
        }), []);
  return null;
}

var ConsentManager = {
  make: ConsentManagerDialog$ConsentManager
};

export {
  getSegmentWriteKey ,
  reloadPage ,
  ConsentManager ,
}
/* react Not a pure module */
